import React, { useState } from 'react'
import { Auth } from 'firebase/auth'
import { auth, db } from '../firebase'
import { PiSignOutBold } from 'react-icons/pi';
import { useAuthState } from 'react-firebase-hooks/auth';

const SignOut = () => {

  

  const [showSignoutDialog, setShowSignoutDialog] = useState(false) 

  return (
    <button className='btn h-list negative' onClick={()=>{setShowSignoutDialog(!showSignoutDialog)}}>
      sign out
    <PiSignOutBold style={{"marginLeft":"5px"}} />
    {showSignoutDialog&&
      <div className='overlay'>
        <div className='dialog'>
          <h3>Sign out from {auth.currentUser.email}?</h3>
          <div className='h-list even'>
            <button className='btn inactive' onClick={()=>{setShowSignoutDialog(false)}}>Cancel</button>
            <button className='btn negative' onClick={()=>{auth.signOut()}}>Sign out</button>
          </div>
            
        </div>
      </div>
    }
    </button>
    
  )
}

export default SignOut